"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var React = require("react"),
  LeftArrow = function (_a) {
    var customLeftArrow = _a.customLeftArrow,
      getState = _a.getState,
      previous = _a.previous,
      disabled = _a.disabled,
      rtl = _a.rtl;
    if (customLeftArrow) return React.cloneElement(customLeftArrow, {
      onClick: function () {
        return previous();
      },
      carouselState: getState(),
      disabled: disabled,
      rtl: rtl
    });
    var rtlClassName = rtl ? "rtl" : "";
    return React.createElement("button", {
      "aria-label": "Go to previous slide",
      className: "react-multiple-carousel__arrow react-multiple-carousel__arrow--left " + rtlClassName,
      onClick: function () {
        return previous();
      },
      type: "button",
      disabled: disabled
    });
  };
exports.LeftArrow = LeftArrow;
var RightArrow = function (_a) {
  var customRightArrow = _a.customRightArrow,
    getState = _a.getState,
    next = _a.next,
    disabled = _a.disabled,
    rtl = _a.rtl;
  if (customRightArrow) return React.cloneElement(customRightArrow, {
    onClick: function () {
      return next();
    },
    carouselState: getState(),
    disabled: disabled,
    rtl: rtl
  });
  var rtlClassName = rtl ? "rtl" : "";
  return React.createElement("button", {
    "aria-label": "Go to next slide",
    className: "react-multiple-carousel__arrow react-multiple-carousel__arrow--right " + rtlClassName,
    onClick: function () {
      return next();
    },
    type: "button",
    disabled: disabled
  });
};
exports.RightArrow = RightArrow;